// extracted by mini-css-extract-plugin
export var buttonContent = "_2g-0";
export var centered = "_2g-1";
export var centeredFlex = "_2g-2";
export var errorText = "_2g-3";
export var icon = "_2g-4";
export var iconButtonContent = "_2g-5";
export var monospace = "_2g-6";
export var padded = "_2g-7";